<script setup>
import { reactive } from 'vue'
import { VueFinalModal } from 'vue-final-modal'

const props = defineProps([
    'contentTransition'
])

const state = reactive({
    contentTransition: props.contentTransition ?? 'vfm-fade'
})
</script>

<template>
     <VueFinalModal
        class="c-modal"
        content-class="c-modal__wrapper"
        overlay-transition="vfm-fade"
        :content-transition="state.contentTransition"
    >

        <button @click="$emit('close')" class="close">
            <img src="/img/icons/close.svg" alt="">
        </button>

        <div class="c-modal__content">
            <slot />
        </div>
    </VueFinalModal>
</template>